bw = require './server/wsgame/binary-wheel'

Angle = bw.scaled bw.uint16, -Math.PI, Math.PI
AngleRange = bw.scaled bw.uint16, 0, Math.PI*2
Radius = bw.scaled bw.uint8, 0, 256
Position = bw.scaled bw.uint16, -1200, 1200
Velocity = bw.scaled bw.uint16, -256, 256
Alpha = bw.scaled bw.uint8, 0, 1
Dir = bw.scaled bw.uint8, -Math.PI, Math.PI

BodyType = bw.enum [
	'Ship', 'Missile', 'Blast', 'BombBlast', 'FlakBlast', 'RayBlast', 'Bomb'
	'Asteroid', 'BlackHole', 'WarpEnter', 'WarpExit', 'Hook', 'BonusLife', 'BonusWeapon', 'BonusUpgrade']

WeaponType = bw.enum [
	'Blaster', 'Missiles', 'BombGun', 'Flak', 'Ray'
	'Boost', 'Force', 'Shield', 'BlackHoleGun', 'WarpGun', 'HookGun']

Emotion = bw.enum ['SmileFace', 'SadFace', 'WinkFace', 'EvilFace', 'InviteToTeam', 'LeaveTeam', 'JoinTeam']

RadarPointType = bw.enum ['Friend', 'Enemy', 'Revenge', 'Leader']

BodyChange = bw.struct
	id: bw.uint8
	x: Position
	y: Position
	vx: Velocity
	vy: Velocity
	a: bw.optional Angle
	life: bw.optional Alpha
	shield: bw.optional Alpha
	emotion: bw.optional Emotion
	skillType: bw.optional WeaponType
	owner: bw.optional bw.uint8
	level: bw.optional bw.uint8

PlayerInfo = bw.struct
	name: bw.string
	ship: bw.uint8
	color0: bw.uint8
	color1: bw.uint8

PlayerScore = bw.struct
	leaderKill: [bw.bool, false]
	revengeKill: [bw.bool, false]
	multiKill: [bw.uint8, 0]
	roundScore: [bw.uint8, 0]

PlayerDied = bw.struct
	slayer: bw.optional bw.uint8
	weapon: bw.optional WeaponType

Controls = bw.struct
	x: Position
	y: Position
	keepDirection: bw.bool
	weaponState: bw.list bw.struct
		active: bw.bool
		fire: bw.bool
		target: bw.optional bw.uint8
	emotion: bw.optional Emotion
	respawn: bw.bool

GameUpdate = bw.struct
	playerState: bw.struct
		id: bw.uint8
		alive: bw.bool
		energy: [Alpha, 0]
		levelProgress: [Alpha, 0]
		skills: bw.list bw.struct
			type: WeaponType
			level: bw.uint8
			cooldown: Alpha
	createdPlayers: bw.list bw.struct
		id: bw.uint8
		info: PlayerInfo
		bot: bw.bool
	changedPlayers: bw.list bw.struct
		id: bw.uint8
		level: bw.uint8
		score: PlayerScore
		team: bw.optional bw.uint8
		died: bw.optional PlayerDied
	deletedPlayers: bw.list bw.uint8
	round: bw.struct
		killsToWin: bw.optional bw.uint16
		winner: bw.optional bw.uint8
	origin: bw.struct
		x: bw.float32
		y: bw.float32
	deletedBodies: bw.list bw.uint8
	createdBodies: bw.list bw.struct
		id: bw.uint8
		type: bw.optional BodyType
		radius: bw.optional Radius
		x: Position
		y: Position
	changedBodies: bw.list BodyChange
	explosions: bw.list bw.struct
		x: Position
		y: Position
		power: bw.uint8
		type: BodyType
	radarPoints: bw.list bw.struct
		distance: Alpha
		a: Dir
		type: RadarPointType

module.exports = {
	Angle, AngleRange, Radius, Position, Velocity, Alpha, Dir, BodyType, WeaponType, Emotion, RadarPointType
	BodyChange, GameUpdate, PlayerInfo, PlayerScore, PlayerDied, Controls}



// WEBPACK FOOTER //
// ./proto.bw.coffee